import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'item-form-error',
	templateUrl: './item-form-error.component.html',
	imports: [ CommonModule, LowerCasePipe, TranslatePipe, FormsModule ]
})
export class ItemErrorComponent implements OnInit {
	
	@Input() fieldName: any;
	@Input() noOffset: any | undefined;
	@Input() error: any;
	
	constructor() {}
	
	ngOnInit() {

	}
	
	getErrors() {
		if (!this.error) {
			return [];
		}
		if (!Array.isArray(this.error)) {
			this.error = [this.error];
		}
		return this.error;
	}
}